import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { alertPermissionsRequired } from "../../actions/messages";

const PrivateRoute = ({ component: Component, auth, ...rest }) => (

	<Route
		{...rest}
        
		render={(props) => {
			if (auth.status !== "authenticated") {
                // if auth error OR localstore !=== logged in, redirect
                // if auth error, redirect and send message "authentication error"
                if (!localStorage.getItem('logged_in') || auth.status === "authError") {
                    return <Redirect to="/login" />;
			    } else return <h2 className="loader" >Loading...</h2>;
			} else {
				return <Component {...props} {...rest} />;
			}
		}}
	/>
);

const mapStateToProps = (state) => ({
	auth: state.auth
});

export default connect(mapStateToProps)(PrivateRoute);

// const status2 = localStorage.getItem('logged_in');
//     console.log("status2: " + status2)